var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.9 16.1l-7.5-7.3 7.4-7.4L16.4 0 8.9 7.4 1.4.1 0 1.6l7.5 7.3-7.4 7.4 1.4 1.4L9 10.2l7.5 7.4"}));
}

Cross.defaultProps = {"viewBox":"0 0 17.9 17.7","className":"close--2jTaK","style":{"width":"20px"}};

module.exports = Cross;

Cross.default = Cross;
